//@flow
import React, { Component } from 'react';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import type { ModalTypesFlowType } from 'app/common/react/components/growth/unauth/signup/constants';

type Props = {|
  container: ?string,
  darkSignupTitle?: boolean,
  hybridTier?: string,
  modalType: ModalTypesFlowType,
  titleText: string,
|};

const styles = {
  signupTitle: {
    color: '#333',
    fontSize: '32px',
    fontWeight: 'bold',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    letterSpacing: '-1.2px',
  },
};

export default class FullPageSignupTitle extends Component<Props> {
  componentDidMount = () => {
    const { container, hybridTier, modalType } = this.props;

    trackRegisterAction('web.unauth.modal_title.view');

    //aiming for parity here with unauth_web_container stat
    trackRegisterAction(
      `unauth_web_modal.${container || 'unknown'}.${hybridTier ||
        'undefined_tier'}.${modalType}.shown`,
    );
  };

  getSignupTitleStyles = () => {
    const { darkSignupTitle } = this.props;

    let signupTitleStyles = styles.signupTitle;

    if (darkSignupTitle) {
      signupTitleStyles = { ...signupTitleStyles, color: '#000' };
    }

    return signupTitleStyles;
  };

  render() {
    const { titleText } = this.props;
    const signupTitleStyles = this.getSignupTitleStyles();

    return <h3 style={signupTitleStyles}>{titleText}</h3>;
  }
}
